import { PaymentMethodsEnum } from '../../../../../views/phone-answering/constants';

export default {
  options: {
    [PaymentMethodsEnum.Cash]: 'Contanti',
    [PaymentMethodsEnum.Online]: 'Online',
    [PaymentMethodsEnum.InStoreCard]: 'Carta in negozio',
  },
};
